import getNewVendorPlacement from '../../../support/helpers/getNewVendorPlacement';

import { Market } from '../../../types/shared/Market';
import { VendorList } from '../../../types/shared/Vendor';
import { PlacementByVendor } from '../../../types/shared/Placement';

/**
 * Used to get the list of percentage, representing how full a spot is for the entire market duration.
 */
function getPercentageList(
  vendors: VendorList,
  placement: PlacementByVendor,
  market: Market,
) {
  let percentageList = [];
  let marketSpots = market.num_spots;
  let marketDatesLength = market.dates.length;

  for (let position = 1; position <= marketSpots; position++) {
    let placementByDate = getNewVendorPlacement(market, position, {
      vendors,
      placement,
    });

    let percentage =
      (Object.keys(placementByDate).length / marketDatesLength) * 100;
    percentageList.push(percentage);
  }
  return percentageList;
}

export default getPercentageList;
